import { Grid, Typography, useMediaQuery } from '@mui/material'
import FormikTextField from './FormikTextField'

export default function BeneficiaryFields({
  formik,
  optionalFields = false,
  contactFields = false
}: any) {
  const isSm = useMediaQuery((theme: any) => theme.breakpoints.down('sm'))

  return (
    <>
      <Grid item xs={12}>
        <Typography
          component="h3"
          variant={isSm ? 'h6' : 'h4'}
          color="primary"
          display="inline-block"
          lineHeight="unset"
          marginLeft="5px"
          marginBottom={'15px'}
          marginTop={'15px'}
          align="left"
        >
          {formik.values.referralLink !== 'self'
            ? formik.values.referralLink === 'other'
              ? 'Informations du bénéficiaire'
              : "Votre demande d'aide concerne"
            : 'Vos informations de contact'}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <FormikTextField
          name="firstNameBenef"
          label={
            formik.values.referralLink === 'self'
              ? 'Prénom'
              : 'Prénom du bénéficiaire'
          }
          formik={formik}
        />
      </Grid>
      <Grid item xs={6}>
        <FormikTextField
          name="lastNameBenef"
          label={
            formik.values.referralLink === 'self'
              ? 'Nom de famille'
              : 'Nom de famille du bénéficiaire'
          }
          formik={formik}
        />
      </Grid>
      {contactFields && (
        <>
          <Grid item xs={6}>
            <FormikTextField
              name="phoneBenef"
              label={
                formik.values.referralLink === 'self'
                  ? 'Téléphone'
                  : 'Téléphone du bénéficiaire'
              }
              formik={formik}
            />
          </Grid>
          <Grid item xs={6}>
            <FormikTextField
              name="emailBenef"
              label={
                formik.values.referralLink === 'self'
                  ? 'Email'
                  : 'Email du bénéficiaire'
              }
              formik={formik}
            />
          </Grid>
        </>
      )}
      {optionalFields && (
        <>
          {/* <Grid item xs={12} style={{ marginBottom: '20px' }}>
            <TextField
              fullWidth
              id="birthdayBenef"
              name="birthdayBenef"
              type="date"
              label={'Date de naissance du bénéficiaire'}
              InputLabelProps={{
                shrink: true
              }}
              value={formik.values.birthdayBenef}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.birthdayBenef &&
                Boolean(formik.errors.birthdayBenef)
              }
              helperText={
                formik.touched.birthdayBenef && formik.errors.birthdayBenef
              }
            />
          </Grid> */}
          {/* <Grid item xs={12} style={{ marginBottom: '20px' }}>
            <FormControl fullWidth>
              <InputLabel id="days-of-intervention-label">
                Jours d'intervention
              </InputLabel>
              <Select
                multiple
                labelId="days-of-intervention-label"
                id="days-of-intervention"
                value={formik.values.daysOfIntervention}
                label="Jours d'intervention"
                onChange={e => {
                  formik.setFieldValue('daysOfIntervention', e.target.value)
                }}
              >
                <MenuItem value={'MONDAY'}>Lundi</MenuItem>
                <MenuItem value={'TUESDAY'}>Mardi</MenuItem>
                <MenuItem value={'WEDNESDAY'}>Mercredi</MenuItem>
                <MenuItem value={'THURSDAY'}>Jeudi</MenuItem>
                <MenuItem value={'FRIDAY'}>Vendredi</MenuItem>
                <MenuItem value={'SATURDAY'}>Samedi</MenuItem>
                <MenuItem value={'SUNDAY'}>Dimanche</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
          {/* <Grid item xs={12} style={{ marginBottom: '20px' }}>
            <TextField
              fullWidth
              id="hourVolume"
              name="hourVolume"
              type="number"
              label={"Volume d'heures"}
              value={formik.values.hourVolume}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.hourVolume && Boolean(formik.errors.hourVolume)
              }
              helperText={formik.touched.hourVolume && formik.errors.hourVolume}
            />
          </Grid> */}
        </>
      )}
    </>
  )
}
